import { useContextState } from "../../../../../../../../hooks/theme"
import { useTheme } from "@mui/material"


const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()
  return {
    containerHeader: (parentId:boolean) =>  ({
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        justifyContent: 'space-between',
        alignItems: 'center',
        [breakpoints.down(1160)]: {
            display: parentId ? 'block':'flex'
          },
    }),
    headerTitle: {
        fontSize: '16px',
        flex: '1 0 200px',
        fontWeight: '600',
        wordBreak: 'break-word',
        //overflowWrap: 'break-word',
        color: colors.color9
    },
    box: {
        maxWidth:'max-content',
    },
    headerSecondTitle: {
        fontSize: '14px',
        maxWidth:'800px',
        fontWeight: '600',
        wordBreak: 'break-word',
        color: colors.color9
    },
    headerSubTitle: {
        fontSize: '14px',
        color: colors.color9
    },
    headerAction: (parentId:boolean) =>  ( {
        flex: '0 1 300px',
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        '& .MuiSvgIcon-root': {
            fontSize: '25px'
        },
        [breakpoints.down(1160)]: {
            justifyContent: parentId ? 'start':'end',
          },
    }),
    arrow: {
        padding: 0,
        '& .MuiSvgIcon-root': {
            fontSize: '2rem',
        }
    },
    rotate: (expand: boolean | undefined ) => ({
        transition: '200ms',
        transform: `rotate(${expand ? '180deg' : '0deg'})`,
        '& .MuiSvgIcon-root': {
            fontSize: '2rem',
        }
    }),
    accordion: {
        padding: '8px 16px',
            margin: 0,
        '&.MuiAccordion-root':{
            marginBottom: 2
        },
        '& .MuiAccordion-root.Mui-expanded': {
            margin: 0
        },
        '& .MuiAccordionSummary-root': {
            cursor: 'default !important',
        }
    },
    addService: {
      color: colors.color4,
      borderRadius:'0px',
      padding: '6px',
      '&.mt':{
        marginTop:'20px',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '0.5em',
      },
    },
    description: {
        padding:'0px 0px 0px 24px',
    },
    status: (flag:boolean) => ({
        backgroundColor: flag ? colors.color31:colors.color8,
        color:'white', 
        padding: '4px 8px', 
        borderRadius: '50px', 
        minWidth: '100px', 
        textAlign: 'center'
    }),
    titleChild: {
        display:'flex', 
        gap: 4, 
        alignItems: 'center',
        '& .remove-m': {
            margin:0,
            padding:0
          }
    },
    crudModal: {
        width:'60vw',
    },
    crudModalCreate:{
        height:'385px'
    },
    containerRadio:{
        backgroundColor: colors.color39,
        color: colors.color9,
        display:'flex',
        '& .MuiTypography-root':{
            textAlign:'start',
        },
        alignItems:'center',
        padding:1,
        '& span': {
            fontWeight:'bold'
        },
    },
    grid: {
        height:'35vh', 
        overflow:'auto', 
        scrollbarWidth: 'none'
    },
    containerSearchInput: {
        marginBottom:'20px',
        display:'flex',
        justifyContent:'end'
    },
    containerChildren: {
        maxHeight:'450px', 
        padding:'10px 10px 0px 24px',
        marginLeft:'-24px',
        marginRight:'-10px',
        overflowY:'auto', 
        scrollbarWidth: 'none',
    },
    containerSelectButons: {
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        marginBottom:'10px',
    },
    wdth:{
        width:'300px'
    },
    /* list: {
        width: '100%',
        minHeight: '100%',
        'overflowX': 'hidden',
    }, */
  }
}

export { useStyles }
